import { Container } from './Avatar.styles'

import { FunctionComponent } from 'react'
export interface AvatarProps {
  url: string
  onClick?: () => void
  altText?: string
  width: string
  height: string
}

const Avatar: FunctionComponent<AvatarProps> = ({
  url,
  onClick,
  altText,
  width,
  height,
  ...otherProps
}) => {
  return (
    <Container
      {...otherProps}
      src={url}
      onClick={onClick}
      alt={altText}
      width={width}
      height={height}
    />
  )
}

export default Avatar
